const KEYS_TO_KEEP = [
  'txReceipt',
  'balanceDifferences',
  'decodedCallStack',
  'addressVisibility',
  'callStackVisibility',
  'logsVisibility',
];

/**
 * Process Transaction Decode Report JSON data
 * @param {Array} txnData - Array of JSON file objects
 * @param {string} input - User input text
 * @param {Array} uploadedImages - Uploaded images
 * @returns {Object} - Object containing processed JSON files and messages
 */
export const processFullTxnDecode = (txnData, input, uploadedImages) => {
  // Create user message
  const userMessage = {
    role: 'user',
    content: [
      {
        type: 'text',
        text: input, // inputmessage is fetched from actionplan default
      },
      ...(uploadedImages
        ? uploadedImages.map((m) => ({ type: 'image', image: m[0] }))
        : []),
    ],
  };

  return {
    messages: {
      userMessage,
    },
  };
};

